
const guaranteeCompanyList = [{
  name: '锦泰保险担保公司全称',
  logoUrl: require('./../assets/image/logo.png'),
  code: 'abc',
}, {
  name: '锦泰保险担保公司全称锦泰保险担保公司全称锦泰保险担保公司全称锦泰保险担保公司全称',
  logoUrl: require('./../assets/image/logo.png'),
  code: 'def',
}];
export {
  guaranteeCompanyList,
};
